<div class="standard-row" [style.background-color]="resolvedTableBackgroundColor">
  <div class="image-section">
    <div class="image-container">
      @if (itemImage) {
        <gb-image [image]="itemImage" [cover]="imageCover"></gb-image>
      } @else {
        <div class="image-placeholder"></div>
      }
    </div>
  </div>

  <div class="details-section" [style.font-size.cqw]="fontSize" [style.color]="backgroundContrastColor">
    @let itemNameMaxLines = itemTableWidget.item_name_max_lines ?? 2;
    <div
      class="item-name"
      [style.-webkit-line-clamp]="itemNameMaxLines"
      [style.display]="'-webkit-box'"
      [style.-webkit-box-orient]="'vertical'"
      [style.white-space]="'normal'"
    >
      {{ item.name }}
    </div>
    <div class="meta-row">
      <div class="item-code">{{ item.alias }}</div>
      @if (itemTableWidget.show_item_type) {
        <div class="item-type gb-truncate">{{ itemTypeTranslateKey | translate }}</div>
      }
    </div>
  </div>

  <div
    class="right-section"
    [style.background-color]="resolvedTablePrimaryColor"
    [style.color]="primaryContrastColor"
    [style.font-size.cqw]="fontSize"
  >
    @if (item.item_type === ItemTypeEnum.Bidding) {
      @if (biddingSoldOut) {
        <span>
          {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.SOLD_OUT' | translate }}
        </span>
      } @else {
        @if (hasWinningBids) {
          <span>{{ highestBidderName }}</span>
          <span>{{ highestBidAmount | gbCurrency }}</span>
        } @else {
          <span>
            {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.STARTING_BID' | translate }}
          </span>
          <span>{{ item.bidding_item?.starting_price | gbCurrency }}</span>
        }
      }
    }

    @if (item.item_type === ItemTypeEnum.Raffle) {
      <span>
        {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.TICKETS_REMAINING' | translate }}
      </span>
      <span>{{ ticketsRemaining }}</span>
    }

    @if (item.item_type === ItemTypeEnum.Donation) {
      <span>{{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.RAISED' | translate }}</span>
      <span>{{ donationRaised | gbCurrency }}</span>
    }

    @if (item.item_type === ItemTypeEnum.Purchase) {
      <span>
        {{ 'PRESENTER.ITEM_TABLE_CARD_COMPACT.REMAINING' | translate }}
      </span>
      <span>{{ item.purchase_item?.units_remaining }}</span>
    }
  </div>
</div>
